export default __webpack_public_path__ + "static/media/05.ffb07749.png";